export const DEFAULT_NOTE_LIMIT = 50;

// Modal title if there's an error.
export const ERROR_TITLE = "Notes Request Failed";
